// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PageFooter{flex-shrink:0;padding:20px 15px 65px;margin-bottom:60px}@media (min-width: 768px){.PageFooter{padding:40px}}@media (min-width: 1024px){.PageFooter{padding-left:150px;margin-bottom:0}}.PageFooter-Text{color:#999}.PageFooter-Socials{padding-top:20px}\n", ""]);
// Exports
module.exports = exports;
